import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 */
class CategoryService {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createCategory = async (payload) => {
    const createdCategory = await Helpers.post({
      url: Constants.CATEGORIES,
      data: payload,
    });
    return createdCategory;
  };

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param searchKeyword
   * @return {Promise<*>}
   */
  getCategories = async (orgId, page, limit, searchKeyword) => {
    let url = `${Constants.CATEGORIES}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

    const categories = Helpers.get({ url });
    return categories;
  };

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updateCategory = async (payload) => {
    const updateCategory = await Helpers.put({
      url: Constants.CATEGORIES,
      data: payload,
    });
    return updateCategory;
  };

  /**
   *
   * @param {*} payload
   * @return
   */
  deleteCategory = async (payload) => {
    const category = await Helpers.delete({
      url: Constants.CATEGORIES,
      data: payload,
    });
    return category;
  }

  // create sub category
  createSubCategory = async (payload) => {
    const createdSubCategory = await Helpers.post({
      url: Constants.CREATE_SUB_CATEGORY,
      data: payload,
    });
    return createdSubCategory;
  };

  // get sub category
  getSubCategories = async (searchKeyword, page, limit) => {
    let url = `${Constants.CREATE_SUB_CATEGORY}?`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

    const subCategories = Helpers.get({ url });
    return subCategories;
  };
}
export default new CategoryService();
